import { createStore } from 'vuex'

export default createStore({
  state: {
    showDrawer: false,
  },
  getters: {
    isShowDrawer: state => state.showDrawer,
  },
  mutations: {
    setShowDrawer(state, data) {
      state.showDrawer = data;
      //console.log('Drawer to show: ', state.showDrawer);
    },
  },
  actions: {
    setShowDrawer({commit}, data) {
      commit('setShowDrawer',data)
    }
  },
  modules: {
  }
})
